import axiosV1 from '@/plugins/axios/configV1';

export default {
  addCode(...payload) {
    return axiosV1.post('products/pins', ...payload)
  },
  getCode(id=null) {
    return axiosV1.get(`products/pins/view/${id}`)
  },
  getCodes(params) {
    return axiosV1.get(`products/pins`, { params });
  },
  updateCode(id=null, ...payload) {
    return axiosV1.post(`products/pins/update/${id}`, ...payload)
  },
  deleteCode(id=null) {
    return axiosV1.post(`products/pins/delete/${id}`)
  },
  deleteCodes(ids=null) {
    return axiosV1.post(`products/pins/bulk/delete`, ids)
  },
  destroyCode(id=null) {
    return axiosV1.post(`products/pins/destroy/${id}`)
  },
  destroyCodes(ids=null) {
    return axiosV1.post(`products/pins/bulk/destroy`, ids)
  },
  recoverCode(id=null) {
    return axiosV1.post(`products/pins/recover/${id}`)
  },
  recoverCodes(ids=null) {
    return axiosV1.post(`products/pins/bulk/recover`, ids)
  },
  importCode(file=null) {
    let formData = new FormData();
    formData.append('file', file);
    axiosV1.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    return axiosV1.post(`products/pins/import`, formData)
  },
  exportExcel(params) {
    return axiosV1.get('products/pins/export', { params });
  },
  bulkEditCode(...payload) {
    return axiosV1.post('products/pins/bulk/update', ...payload);
  },
};
